import React from 'react';
import { Title } from 'ui-library';
import { useTranslation } from 'react-i18next';
import ChartType from 'components/ChartType/ChartType';
import { PIE } from 'constants/constants';
import { useFormatting } from 'locale';
import { allocationPercentFormat } from 'utils/formatting';
import { CHART_SIZE } from 'pages/ClientOverview/constants';
import Preloader from '../../../../../components/Preloader';

// --- Interfaces ---

export interface Allocation {
    name: string;
    value: number;
    color?: string;
    ExternalId?: string | number;
}

export interface SelectedProduct {
    Name?: string;
    Description?: string;
}

interface AllocationChartProps {
    isLoading?: boolean;
    isHidden?: boolean;
    selectedProduct?: SelectedProduct;
    allocations?: Allocation[];
    factsheetUrl?: string;
}

// --- Component ---

const AllocationChart: React.FC<AllocationChartProps> = ({
    isLoading = true,
    isHidden = true,
    selectedProduct = {},
    allocations = [],
    factsheetUrl = '',
}) => {
    const { t } = useTranslation();
    const { getFormattedXAxisFormat } = useFormatting();

    return (
        <div
            className="fi-product-mark-selection-chart"
            hidden={isHidden}
        >
            <Preloader
                isLoading={isLoading}
            >
                <Title type={2}>{selectedProduct.Name}</Title>
                <div className="fi-strategy-layout fi-strategy-layout--pie-chart">
                    <div className="fi-pie-chart">
                        <ChartType
                            data={allocations}
                            chartView={PIE}
                            percentFormat={allocationPercentFormat}
                            xAxisFormat={getFormattedXAxisFormat}
                            chartSize={CHART_SIZE.INVESTMENT_STRATEGY_CHART}
                        />
                    </div>
                    <div className="fi-product-description">
                        {selectedProduct.Description && selectedProduct.Description.split('\n').map((item) => {
                            const trimItem = item.trim();

                            if (trimItem.length > 0) {
                                return (
                                    <p className="paragraph" key={trimItem}>
                                        {trimItem}
                                    </p>
                                );
                            }

                            return null;
                        })}

                        {!!factsheetUrl && (
                            <a
                                href={factsheetUrl}
                                target="_blank"
                                className="button"
                                rel="noreferrer"
                            >
                                {t('portfolio.createNewPortfolio.strategy.factsheetUrl')}
                            </a>
                        )}
                    </div>
                </div>
            </Preloader>
        </div>
    );
};

export default AllocationChart;
